import React from 'react'
import { Grid } from '@mui/material'
import PropTypes from 'prop-types'

import PageLayout from '../../../common/Layout/Page/PageLayout'
import useOrbitFlag from '../../../hooks/useOrbitFlag'

import ActivatedSimsCell from './ActivatedSimsCell'
import BundleMgmtCell from './BundleMgmtCell'
import CompanyProfileCell from './CompanyProfileCell'
import DataVoiceSms from './DataVoiceSms'
import TeamMembersCell from './TeamMembersCell'
import TotalExpenditureCell from './TotalExpenditureCell'
function Panel({
  team,
  teamMembers,
  bundleUsage,
  bundle,
  convertData,
  convertVoice,
  setPage,
  teamOptions,
  setTeam,
  date
}) {
  // ------------------------------ Flags ---------------------------------
  // |       These flags are generated from the Unleash Pro server        |
  // |   To update, go to https://us.app.unleash-hosted.com/usee0004/     |
  // ----------------------------------------------------------------------
  const FlagDemo = useOrbitFlag('demo')
  const FlagActivatedSims = useOrbitFlag('dashboard-activatedSims')
  const FlagBundleMgmt = useOrbitFlag('dashboard-bundleMgmt')
  const FlagTotalCost = useOrbitFlag('dashboard-totalCost')
  const FlagUsageCharts = useOrbitFlag('dashboard-usageCharts')
  const FlagSimList = useOrbitFlag('dashboard-simList')

  return (
    <div id='dashboard__body'>
      <PageLayout header='Dashboard'>
        <Grid container spacing={2}>
          {/* hidden under demo account */}
          {FlagDemo && (
            <Grid item xs={12} md={6}>
              <CompanyProfileCell team={team} />
            </Grid>
          )}
          {FlagDemo && (
            <Grid item sm={12} md={6}>
              <ActivatedSimsCell bundle={bundle} bundleUsage={bundleUsage} />
            </Grid>
          )}

          {/* Bundle Management */}
          {FlagBundleMgmt && (
            <Grid item xs={12}>
              <BundleMgmtCell
                bundle={bundle}
                bundleUsage={bundleUsage}
                team={team}
                setTeam={setTeam}
                teamOptions={teamOptions}
              />
            </Grid>
          )}

          {/* Total Expenditure */}
          {FlagTotalCost && (
            <Grid item sm={12} md={6}>
              <TotalExpenditureCell bundleUsage={bundleUsage} date={date} />
            </Grid>
          )}
          {FlagActivatedSims && (
            <Grid item sm={12} md={6}>
              <ActivatedSimsCell bundle={bundle} bundleUsage={bundleUsage} />
            </Grid>
          )}

          {/* Usage Charts */}
          {/* TODO(sn): Convert to bars */}
          {FlagUsageCharts && (
            <Grid item sm={12}>
              <DataVoiceSms
                bundleUsage={bundleUsage}
                bundle={bundle}
                convertData={convertData}
                convertVoice={convertVoice}
              />
            </Grid>
          )}

          {FlagSimList && (
            <Grid item sm={12}>
              <TeamMembersCell
                bundle={bundle}
                bundleUsage={bundleUsage}
                teamMembers={teamMembers}
                setPage={setPage}
              />
            </Grid>
          )}
        </Grid>
      </PageLayout>
    </div>
  )
}

Panel.propTypes = {
  team: PropTypes.string,
  teamMembers: PropTypes.array,
  bundleUsage: PropTypes.object,
  bundle: PropTypes.object,
  convertData: PropTypes.func,
  convertVoice: PropTypes.func,
  setPage: PropTypes.func,
  teamOptions: PropTypes.array,
  setTeam: PropTypes.func,
  date: PropTypes.string
}

export default Panel
